import styled from 'styled-components';

import { Link } from 'react-router-dom';
import { ReactComponent as Question } from 'assets/icons/question-icon.svg'

export const Container = styled.div``

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 50px;

  position: relative;

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
  }
`
export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .faq__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`

export const FAQSection = styled.section`
  width: 97%;
  max-width: 1010.22px;
  height: fit-content;
  margin: 0 auto;

  display: flex;
  flex-direction: row;

  .faq__section-questions-container{
    width: 100%;
    max-width: 613.22px;
    height: fit-content;
  }

  .faq__section-questions__search-label{
    width: 100%;
    max-width: 598.74px;
    height: 73.2px;
    padding: 0 25px;

    display: block;

    overflow: hidden;
    border-radius: 33px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.26);
  }

  .faq__section-questions__search-input{
    width: 87.5%;
    height: 100%;
    padding: 0 15px;

    display: inline-block;

    font-size: 1.75rem;
    font-weight: lighter;
    color: var(--blue00);
    border: 0;
    outline: none;
  }

  .faq__section-questions__search-icon{
    width: 10%;
    height: fit-content;
    margin-left: 2.5%;

    display: inline-block;

    vertical-align: middle;

    > svg{
      width: 70%;
      height: auto;
    }
  }

  .faq__section-help-anchor{
    max-width: 294px;
    height: fit-content;
    margin: 0 auto;

    color: var(--blue00);
    line-height: 2.1rem;
    font-size: 1.375rem;
    text-decoration: none;
  }

  .faq__section-questions__list{
    margin-top: 43.7px;
  }

  .faq__section-questions__list-item{
    width: 100%;
    height: fit-content;

    background-color: var(--bluef0);
    border-radius: 9px;

    &:not(:first-child){
      margin-top: 32.1px;
    }
  }

  .faq__section-questions__list-item-summary{
    width: 100%;
    height: fit-content;
    min-height: 111.76px;
    padding: 40px 21.7px;

    display: flex;
    justify-content: flex-start;
    align-items: center;

    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  .faq__section-questions__list-item-title{
    width: 100%;
    max-width: 500px;
    height: fit-content;

    color: var(--blue00);
    font-size: 1.4375rem;
    word-break: break-all;
  }

  .faq__section-questions__list-item-p{
    width: 90%;
    height: fit-content;
    padding: 0 0 20px;
    margin: 0 auto;

    line-height: 1.75rem;
    word-break: break-all;
    animation: entering 0.5s ease-in-out;
    white-space: pre-line;
  }

  @media (max-width: 1010.22px){
    padding: 0 0 80px;

    flex-direction: column;

    .faq__section-help-anchor{
      margin: 40px auto 0;
    }
  }
`

export const QuestionIcon = styled(Question)`
  width: 44.38px;
  height: auto;
  margin-right: 22.6px;

  display: inline-block;
`
